export default __webpack_public_path__ + "static/media/wave_small.fb3e57cd.svg";